module.exports = __webpack_public_path__ + "img/GH-kyujin-top-019.5923c35e.webp";